/* ControlActivityPage — §41-43 */
import React, { useCallback, useEffect, useState } from "react";
import { controlApi } from "../lib/controlApi";
import { CheckCircle2, AlertTriangle, XCircle, Zap, RefreshCw, Loader2 } from "lucide-react";

export default function ControlActivityPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const load = useCallback(async (silent = false) => {
    if (silent) setRefreshing(true); else setLoading(true);
    try {
      const r = await controlApi.activity(50);
      setItems(r.items || []);
    } catch { /* noop */ } finally { setLoading(false); setRefreshing(false); }
  }, []);
  useEffect(() => { load(); const t = setInterval(() => load(true), 30000); return () => clearInterval(t); }, [load]);

  const iconFor = (it) => {
    if (it.type === "incident") {
      if (it.status === "resolved") return { Icon: CheckCircle2, color: "text-emerald-600" };
      if (it.severity === "critical") return { Icon: XCircle, color: "text-red-600" };
      return { Icon: AlertTriangle, color: "text-amber-600" };
    }
    return { Icon: CheckCircle2, color: "text-blueblack" };
  };

  return (
    <div className="p-4 space-y-3" data-testid="spc-activity">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.35em] text-textgray">Actividad</div>
          <div className="font-serif text-2xl font-bold text-blueblack">Feed operativo</div>
        </div>
        <button onClick={() => load(true)} disabled={refreshing}
          className="w-10 h-10 flex items-center justify-center border border-softblue bg-white">
          {refreshing ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
        </button>
      </div>
      {loading ? (
        <div className="text-center p-6"><Loader2 className="w-4 h-4 animate-spin mx-auto text-textgray" /></div>
      ) : items.length === 0 ? (
        <div className="p-8 text-center text-textgray text-xs">Sin actividad reciente.</div>
      ) : (
        <ul className="border border-softblue bg-white divide-y divide-softblue">
          {items.map((it, idx) => {
            const { Icon, color } = iconFor(it);
            return (
              <li key={`${it.type}-${it.at}-${idx}`} className="p-3 flex gap-3">
                <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${color}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-[10px] uppercase tracking-widest text-textgray">
                    {it.at ? new Date(it.at).toLocaleString("es-AR", { timeZone: "America/Argentina/Ushuaia" }) : ""}
                  </div>
                  {it.type === "incident" ? (
                    <>
                      <div className="text-sm font-bold text-blueblack">{it.title}</div>
                      {it.message && <div className="text-xs text-textgray">{it.message}</div>}
                    </>
                  ) : (
                    <div className="text-sm text-blueblack">
                      Tanda {it.run_type} — <b>{it.status}</b>
                      {" · "} {it.published} publicadas
                      {it.urgents ? <> · <Zap className="inline w-3 h-3 text-red-500" /> {it.urgents} urgentes</> : null}
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
